import {
    ButtonPrimary,
    Row,
    RowList,
    Text6,
    IconCheckRegular,
    Text3,
    ButtonFixedFooterLayout,
    skinVars,
    IconInvoicePlanFileRegular,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ContactInfoVerificationStep1 from './contactInfoVerificationStep1';
import './index.scss';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';

const ContactInfoVerification: React.FC = () => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const navigate = useNavigate();
    const [componentSelected, setComponentSelected] = useState<any>();
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    const sendToNative = (url: string) => {
        navigate(url);
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        setComponentSelected(
            <ContactInfoVerificationStep1 fromDesktop={true} setComponentSelected={setComponentSelected} />,
        );
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div
            className='contact-info-verification'
            style={{
                borderLeft: windowWidth >= 1024 ? `24px solid ${skinVars.colors.backgroundSkeleton}` : 'none',
                borderRight: windowWidth >= 1024 ? `24px solid ${skinVars.colors.backgroundSkeleton}` : 'none',
            }}
        >
            {!(isWebviewAndroid || isWebviewIOS) && (
                <div
                    className='contact-info-verification__navigationBar'
                    style={{ background: skinVars.colors.navigationBarBackground }}
                ></div>
            )}
            {windowWidth >= 1024 ? (
                <div className='contact-info-verification__wrapper'>
                    <div className='contact-info-verification__wrapper__left'>
                        <div className='contact-info-verification__wrapper__left__icon'>
                            <IconInvoicePlanFileRegular
                                size={64}
                                color={skinVars.colors.brand}
                            ></IconInvoicePlanFileRegular>
                        </div>
                        <div className='contact-info-verification__wrapper__left__text1'>
                            <Text6 color={skinVars.colors.textPrimary}>{t('contactInfoVerificationTitle')}</Text6>
                        </div>
                        <div className='contact-info-verification__wrapper__left__text2'>
                            <Text3 regular color={skinVars.colors.textSecondary}>
                                {t('contactInfoVerificationSubtitle')}
                            </Text3>
                        </div>
                        <div className='contact-info-verification__wrapper__left__rows'>
                            <RowList>
                                <Row
                                    asset={<IconCheckRegular color={skinVars.colors.neutralHigh}></IconCheckRegular>}
                                    title={t('contactInfoVerification1')}
                                />
                                <Row
                                    asset={<IconCheckRegular color={skinVars.colors.neutralHigh}></IconCheckRegular>}
                                    title={t('contactInfoVerification2')}
                                />
                                <Row
                                    asset={<IconCheckRegular color={skinVars.colors.neutralHigh}></IconCheckRegular>}
                                    title={t('contactInfoVerification3')}
                                />
                                <Row
                                    asset={<IconCheckRegular color={skinVars.colors.neutralHigh}></IconCheckRegular>}
                                    title={t('contactInfoVerification4')}
                                />
                            </RowList>
                        </div>
                    </div>
                    <div className='contact-info-verification__wrapper__right'>{componentSelected}</div>
                </div>
            ) : (
                <>
                    <ButtonFixedFooterLayout
                        button={
                            <ButtonPrimary onPress={() => sendToNative('/obd/verify/contacts')}>
                                {t('onboardingFirstVerButton')}
                            </ButtonPrimary>
                        }
                    >
                        <div className='contact-info-verification__icon'>
                            <IconInvoicePlanFileRegular
                                size={64}
                                color={skinVars.colors.brand}
                            ></IconInvoicePlanFileRegular>
                        </div>
                        <div className='contact-info-verification__text1'>
                            <Text6 color={skinVars.colors.textPrimary}>{t('contactInfoVerificationTitle')}</Text6>
                        </div>
                        <div className='contact-info-verification__text2'>
                            <Text3 regular color={skinVars.colors.textSecondary}>
                                {t('contactInfoVerificationSubtitle')}
                            </Text3>
                        </div>
                        <div className='contact-info-verification__rows'>
                            <RowList>
                                <Row
                                    asset={<IconCheckRegular color={skinVars.colors.neutralHigh}></IconCheckRegular>}
                                    title={t('contactInfoVerification1')}
                                />
                                <Row
                                    asset={<IconCheckRegular color={skinVars.colors.neutralHigh}></IconCheckRegular>}
                                    title={t('contactInfoVerification2')}
                                />
                                <Row
                                    asset={<IconCheckRegular color={skinVars.colors.neutralHigh}></IconCheckRegular>}
                                    title={t('contactInfoVerification3')}
                                />
                                <Row
                                    asset={<IconCheckRegular color={skinVars.colors.neutralHigh}></IconCheckRegular>}
                                    title={t('contactInfoVerification4')}
                                />
                            </RowList>
                        </div>
                    </ButtonFixedFooterLayout>
                </>
            )}
        </div>
    );
};

export default ContactInfoVerification;
